export const apikey = state => state.apikey;
export const isLogged = state => state.isLogged;
export const user = state => state.account;
export const newPasswordVerificationToken = state => state.newPasswordVerificationToken;
export const expiredPassword = state => state.expiredPassword;
